import React from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
import MapView from "./MapView.js";
export default function Map(props) {
  const {
    apiKey
  } = props;
  return /*#__PURE__*/React.createElement(Wrapper, {
    authReferrerPolicy: "origin",
    version: "beta",
    libraries: ['marker'],
    apiKey: apiKey
  }, /*#__PURE__*/React.createElement(MapView, props));
}